import {defineMessages} from 'react-intl';

export default defineMessages({
	productsToReturn: {
		id: 'returnAuthCreateForm.step2.productsInExchange',
		defaultMessage: 'Products you  requested in exchange',
	},
});
